module.exports = __webpack_public_path__ + "img/jsfnd1.388fbe50.png";